import { Analytics } from './analytics'

export namespace SSOAnalyticsTypes {
   export type InitiatedFrom = 'Main menu' | 'Help menu'

   export enum PropertyEvent {
      initiatedFrom = 'Initiated from',
   }

   export enum Events {
      gapAcademyAccessed = 'Gap Academy accessed',
   }
}

export default class SSOAnalytics implements Analytics {
   static onGapAcademyAccessed = (params: { [SSOAnalyticsTypes.PropertyEvent.initiatedFrom]: SSOAnalyticsTypes.InitiatedFrom }) => {
      return Analytics.emitEvent(SSOAnalyticsTypes.Events.gapAcademyAccessed, {
         [SSOAnalyticsTypes.PropertyEvent.initiatedFrom]: params[SSOAnalyticsTypes.PropertyEvent.initiatedFrom],
      })
   }
}
